import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useFunnel } from "@airhelp/funnel";
import { Button, ButtonProps, Flex, Box } from "@chakra-ui/react";
import { trackCtaClick } from "../../../modules/analytics/track";
import { FunnelTrustpilot } from "./FunnelTrustpilot";

const defaultButtonStyles = {
  p: "16px 24px",
  fontSize: "lg",
  minH: "60px",
  fontWeight: "500",
  minW: { base: "100%", md: "170px" },
};

export function FunnelStepControls({ children }: { children: ReactNode }) {
  return (
    <Flex
      mt="2"
      gap="0px 16px"
      alignItems="flex-end"
      flexWrap="wrap-reverse"
      justifyContent={"end"}
    >
      {children}
    </Flex>
  );
}

export function FunnelStepBackControl({
  children,
  customOnClick,
  ...props
}: Omit<ButtonProps, "onClick"> & { customOnClick?: () => void }) {
  const funnel = useFunnel();
  const { t } = useTranslation();
  return (
    <Button
      size="l"
      border="none"
      variant="subtle"
      {...defaultButtonStyles}
      onClick={() => {
        customOnClick?.();
        funnel.stepBack();
        trackCtaClick("Previous step", "Funnel navigation");
      }}
      {...props}
    >
      {children || t("components.step_buttons.back")}
    </Button>
  );
}

export function FunnelStepForwardControl({
  buttonText,
  onClick,
  ...props
}: Omit<ButtonProps, "child"> & { buttonText?: string }) {
  const { t } = useTranslation();
  return (
    <Box minW={{ base: "100%", md: "170px" }}>
      <Button
        mb="32px"
        data-testid="continueButton"
        onClick={(e) => {
          onClick && onClick(e);
          trackCtaClick("Next step", "Funnel navigation");
        }}
        {...defaultButtonStyles}
        {...props}
      >
        <span>{buttonText || t("components.step_buttons.continue")}</span>
      </Button>
      <FunnelTrustpilot
        display={{ base: "flex", md: "none" }}
        m="0px 0 32px"
        sx={{ "@media(width<375px)": { p: { fontSize: "13px" } } }}
      />
    </Box>
  );
}
